import React, { useEffect, useMemo } from "react";
import BasePopup from ".";
import styled from "styled-components";
import imageBody from "../../../../../assets/images/Mini-Game/icon-popup-invite.png";
import bgPopupIntro from "../../../../../assets/images/Mini-Game/bg-popup-invite.png";
import bgBtn from "../../../../../assets/images/Mini-Game/bg-btn-intro.png";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useNavigate } from "@hooks/useNavigate";
import PATH from "../../../../../config/PATH";
import { ID_TAB_MINI_GAME } from "../../../../../helper/const";
import _ from "lodash";
import popupInviteRibbon from "../../../../../assets/images/Mini-Game/popup-invite-ribbon.png";
import BaseIntro from "./indexIntro";

export default function PopupIntro({ open, onCancel }) {
  console.log('onCancel::: ', onCancel);
  
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  // const dispatch = useDispatch();
  // const dataMiniGame = useSelector(curStateMiniGame);

  // useEffect(() => {
  //   if (_.isEmpty(dataMiniGame.dataAwardListMini)) {
  //     dispatch(getDataAwardListMiniGame());
  //   }
  // }, []);

  // const dataAwardSpecial = useMemo(() => {
  //   if (_.isEmpty(dataMiniGame.dataAwardListMini)) {
  //     return {};
  //   }
  //   return dataMiniGame.dataAwardListMini.find((item = {}) => +item.rank === 1);
  // }, [dataMiniGame.dataAwardListMini]);

  if (_.includes(location.pathname, PATH.MINI_GAME)) {
    return null;
  }

  const handleToMinigame = () => {
    navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`);
    onCancel();
  };

  return (
    <Div>
      <BaseIntro
        className={`popup-invite position-relative`}
        backgroundImage={bgPopupIntro}
        getContainer={true}
        open={open}
        onCancel={onCancel}
        maskClosable={false}
      >
        <div className="position-relative">
          <img src={bgPopupIntro} alt="" className="bg-popup-intro" />
          <div className="main-body">
            <img src={popupInviteRibbon} alt="" className="popup-invite-ribbon" />
            <div className="mini-game-text-header">
              <div>
                ¡Completa el rompecabezas ahora para ganar el <strong>Lego del Trofeo de la FIFA 2026</strong> y premios increíbles con la Copa Mundial 2026!{" "}
              </div>
            </div>
            <div className="img-container">
              <img src={imageBody} alt="" className="img-body" />
              <div className="content-btn" onClick={handleToMinigame}>
                {/* <img src={bgBtn} alt="" className="bg-btn" /> */}
                <div className="content-main">¡Participa ahora!</div>
              </div>
            </div>
            <div className="footer-content-intro">
              ¡Gira en la Copa Mundial 2026 para ganar piezas! ¡Completa los rompecabezas para llevarte un{" "}
              <strong>2026 FIFA Trophy Lego </strong>{" "}y muchos premios valiosos!
            </div>
          </div>
        </div>
      </BaseIntro>
    </Div>
  );
}

const Div = styled.div`
  .ant-modal-close-icon {
    position: static !important;
    top: unset !important;
    right: unset !important;
  }

  .content-main {
    /* position: absolute; */
    bottom: 0;
    font-size: 20px;
    bottom: 20px;
    left: 50%;
    /* transform: translateX(-50%); */
    color: white;
    font-weight: 600;
  }

  .rule-mini-close {
    position: absolute;
    z-index: 100;
    right: -9px;
    top: 15px;
  }

  .footer-content-intro {
    padding: 5px 12px;
    text-align: center;
    font-size: 12px;
    color: white;
    font-style: italic;
    line-height: 140%;
    margin-top: 10px;
  }

  .img-container {
    position: relative;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
  }

  .content-btn {
    text-align: center;
    /* position: absolute; */
    /* bottom: -15%; */
    text-align: center;
    left: 50%;
    /* transform: translateX(-50%); */
    width: 100%;
    cursor: pointer;
    background: linear-gradient(to right, #1ea317, #19b810);
    max-width: 360px;
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
  }

  .bg-btn {
    height: 65px;
    width: 82%;
    text-align: center;
    margin: 0 auto;
  }

  .bg-popup-intro {
    max-width: 480px;
    max-height: 680px;
  }

  .img-body {
  }

  .position-relative {
    position: relative;
    width: max-content;
    margin: 0 auto;
  }

  .main-body {
    position: absolute;
    z-index: 2;
    top: 30px;
    width: 100%;
    padding: 0 20px;
  }

  .mini-game-text-header {
    text-align: center;
    color: white;
    font-size: 16px;
    div {
      line-height: 140%;
      font-weight: 500;
    }
  }

  @media (min-width: 992px) {
    .content-btn:hover {
      img {
        scale: 1.03;
        transition: 0.3s ease-in-out;
      }
    }
  }

  @media (max-width: 576px) {
    .bg-popup-intro {
      max-width: 100%;
      min-height: 680px;
    }

    .position-relative {
      width: inherit;
    }
  }
`;
